import { Volume2, VolumeX } from "lucide-react";
import React from "react";
import Icon from "../../assets/icons/Icon";
import { useNavigate } from "react-router-dom";

const NotificationBox = ({ data, onStop, visible,onClose }) => {
  const navigate=useNavigate();
  if (!visible || !data) return null;

  const onViewOrderClick=()=>{
   onClose();
   navigate("/sales/deliverylist", {
  state: {
    isRefresh:true
  },
});
  }
  return (
    <div className="fixed bottom-5 right-5 z-50 w-96 bg-white shadow-2xl rounded-2xl border border-gray-200 overflow-hidden animate-slideIn">

      {/* Header */}
      <div className=" bg-[#f3f6fe] text-black px-4 py-3 flex justify-between items-center">
        <div>
          <p className="text-sm font-semibold tracking-wide">
            NEW ORDER #{data?.transactionNo}
          </p>
        </div>
      
         <div className="flex space-x-2 items-center justify-center">
           
   <button
          onClick={onStop}
          className="bg-white text-red-500 text-xs font-bold px-3 py-1 rounded-full hover:bg-red-100 transition cursor-pointer"
        >
          <VolumeX size={14} />
        </button>
        <span 
                        className="cursor-pointer  w-6 flex items-center justify-center text-[#000000] hover:text-red-500 transition-colors"
                        onClick={onClose}
                    >
                        <Icon type="remove" />
                    </span>
         </div>
     
      </div>

      {/* Body */}
      <div className="p-4 space-y-3">

        {/* Customer */}
        <div>
          <p className="text-gray-800 font-semibold text-base">
            {data?.customerName}
          </p>
          <p className="text-gray-500 text-sm">
            📞 {data?.customerMobileNo}
          </p>
        </div>
          <div>
  <p className="text-xs text-gray-500">Address</p>
  <p className="text-sm text-gray-700 line-clamp-2">
    📍 {
      data?.deliveryCustomerAddress
        ? `${data.deliveryCustomerAddress.Address1}, 
           ${data.deliveryCustomerAddress.Address2}, 
           ${data.deliveryCustomerAddress.City}, 
           ${data.deliveryCustomerAddress.State} - 
           ${data.deliveryCustomerAddress.PostalCode}, 
           ${data.deliveryCustomerAddress.Country}`
        : "N/A"
    }
  </p>
</div>
        {/* Order Info */}
        <div className="flex justify-between bg-gray-50 p-3 rounded-xl">
          <div>
            <p className="text-xs text-gray-500">Items</p>
            <p className="font-semibold text-gray-800">
              {data?.billQty}
            </p>
          </div>

          <div>
            <p className="text-xs text-gray-500">Amount</p>
            <p className="font-semibold text-green-600">
              ₹ {data?.billAmount}
            </p>
          </div>

          <div>
            <p className="text-xs text-gray-500">Paid</p>
            <p className="font-semibold text-blue-600">
              ₹ {data?.billPaidAmount}
            </p>
          </div>
        </div>
         <div onClick={onViewOrderClick} className="rounded-lg text-center text-blue-800 font-semibold cursor-pointer bg-blue-100 p-2 text-xs">
          View Order
        </div>

        {/* Delivery */}
      {/* <div>
  <p className="text-xs text-gray-500">Delivery Time</p>
  <p className="text-sm font-medium text-gray-700">
    ⏰ {data?.deliveryDate}{" "}
    {data?.deliveryTime?.HH &&
      `${data.deliveryTime.HH}:${data.deliveryTime.MM} ${data.deliveryTime.AMPM}`}
  </p>
</div> */}


   


        {/* Status */}
      

      </div>
    </div>
  );
};

export default NotificationBox;
